import { Recap, RecapSection, RecapBullet } from './buildVincoliRecap';

type Translator = (key: string, params?: Record<string, unknown>) => string;

/**
 * Render a bullet line. Only the FIRST level under a section carries a `•`
 * marker — deeper nesting is rendered as indented prose so the eye reads
 * `section → bulleted item → detail` instead of a forest of bullets. When
 * `value` is empty (typical for header bullets that only carry children),
 * the trailing `: ` is dropped.
 */
function emitBullet(b: RecapBullet, indent: string, depth: number): string[] {
  const marker = depth === 0 ? '• ' : '';
  const headLine = b.value
    ? `${indent}${marker}${b.label}: ${b.value}`
    : `${indent}${marker}${b.label}`;
  const lines = [headLine];
  if (b.children) {
    for (const child of b.children) {
      lines.push(...emitBullet(child, indent + '  ', depth + 1));
    }
  }
  return lines;
}

function emitSection(s: RecapSection, indent: string): string[] {
  const lines: string[] = [`${indent}${s.heading}`];
  for (const b of s.bullets) lines.push(...emitBullet(b, indent, 0));
  if (s.subSections) {
    for (const sub of s.subSections) {
      lines.push(...emitSection(sub, indent + '  '));
    }
  }
  return lines;
}

export function renderVincoliRecap(recap: Recap, t: Translator): string {
  const configLineLabel = t('constraints.configurationLineLabel');
  const header = `${configLineLabel}: ${recap.configurationName}`;
  if (recap.sections.length === 0) return header;
  const sectionBlocks = recap.sections.map((s) => emitSection(s, '').join('\n'));
  return `${header}\n\n${sectionBlocks.join('\n\n')}`;
}
